module.exports = __webpack_public_path__ + "img/skillsC-2.f9e1ec49.png";